export enum MessageType {
    None = 0,
    Information = 1,
    Warning = 2,
    Error = 3,
    Question = 4,
    Success = 5
}